import React from "react";
import AppLayout from "../components/AppLayout";
import TrainingBanner from "../components/TrainingBanner";
import TrainingCourses from "../components/TrainingCourses";

const CoursesPage = () => (
    <AppLayout pageTitle="Corsi & Patentini" showBack backTo="/">
        <TrainingBanner />
        <TrainingCourses />
    </AppLayout>
);

export default CoursesPage;
